import { useState } from 'react';

export const useDocumentsModal = ({ isDocumentsLoaded, documentsList }) => {
    const [showDocumentModal, setShowDocumentModal] = useState(false);
    const [documentsToOpen, setDocumentsToOpen] = useState([]);
    const [documentToOpen, setDocumentToOpen] = useState({});


    const handleCloseDocumentsModal = () => {
        setShowDocumentModal(false);
    };
    const handleOpenDocumentsModal = (documentsList, documentToOpen) => {
        const pendingDocuments = documentsList.filter(
            document => !document.isAccepted && document.dmsDocumentType !== documentToOpen?.dmsDocumentType
        );
        const documentToOpenWithFile = documentsList.find(
            document => document.dmsDocumentType === documentToOpen?.dmsDocumentType
        );
        setDocumentsToOpen(documentToOpenWithFile ? [documentToOpenWithFile, ...pendingDocuments] : pendingDocuments);
        setShowDocumentModal(true);

    };
    const handleShowDocumentsModal = documentToOpen => {


        if (isDocumentsLoaded) {
            handleOpenDocumentsModal(documentsList, documentToOpen);
        } else {
            setDocumentToOpen(documentToOpen)
        }
    };

    return {
        showDocumentModal,
        documentsToOpen,
        documentToOpen,
        handleOpenDocumentsModal,
        setDocumentsToOpen,
        handleShowDocumentsModal,
        handleCloseDocumentsModal,
    };
};
